export default {
  formValidateError: '请完善页面中标红的数据问题',
  error: '操作失败'
};
